import { Component, Input, OnChanges, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { CallState } from '@lcs/shared/api';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { getCurrentUserIsSystemUser } from 'src/app/authentication/state/authentication.selector';
import { TwoColumnLayoutService } from 'src/app/common-components/column-layouts/two-column-list-layout/services/selected-id.service';
import { Detail } from 'src/app/common-components/detail/detail';
import { FormsBase } from 'src/app/common-components/forms-base/forms-base';
import { getProviderCallRatePrivileges } from 'src/app/privileges/privileges.selector';
import { SchedulePrivileges } from '../../schedule-register/models/schedule-privileges';
import { CallCostDetailSaveEvent } from '../models/call-cost-detail-form-submit-event';
import { CallCostDetailView } from '../models/call-cost-detail-view.model';
import { CallCostDetailFormService } from '../services/call-cost-detail-form.service';
import * as CallCostDetailActions from '../state/call-cost-detail.actions';
import { getCallCost, getCallCostCallState } from '../state/call-cost-detail.selectors';

@Component({
    encapsulation: ViewEncapsulation.None,
    host: { class: 'entity-detail' },
    providers: [CallCostDetailFormService, { provide: FormsBase, useExisting: CallCostDetailFormService }],
    selector: 'ndt-call-cost-detail',
    templateUrl: './call-cost-detail.component.html',
    standalone: false
})
export class CallCostDetailComponent extends Detail<CallCostDetailFormService> implements OnInit, OnDestroy, OnChanges {
   @Input() providerCallRateId: number;

   callCost$: Observable<CallCostDetailView | null>;

   callState$: Observable<CallState>;

   callCostPrivileges$: Observable<SchedulePrivileges>;

   selectedProviderCallRateId: number;

   constructor(
      public store: Store,
      private router: Router,
      private twoColumnLayoutService: TwoColumnLayoutService,
      protected formService: CallCostDetailFormService
   ) {
      super(store, formService);
      this.callCost$ = this.store.pipe(select(getCallCost));
      this.callState$ = this.store.pipe(select(getCallCostCallState));
      this.callCostPrivileges$ = this.store.pipe(select(getProviderCallRatePrivileges));
      this.isSystemUser$ = this.store.pipe(select(getCurrentUserIsSystemUser));
      this.store.dispatch(CallCostDetailActions.callCostDetailLoad());
   }

   ngOnInit(): void {
      this.router.events.pipe(takeUntil(this.destroyed$)).subscribe((e) => {
         if (e instanceof NavigationEnd) {
            this.store.dispatch(CallCostDetailActions.callCostDetailLoad());
         }
      });
      this.twoColumnLayoutService.selectedId$.pipe(takeUntil(this.destroyed$)).subscribe((id) => {
         if (id !== null) {
            this.selectedProviderCallRateId = id;
            this.store.dispatch(CallCostDetailActions.updateCallCostId({ callCostId: id }));
         }
      });
   }

   ngOnChanges(): void {
      this.store.dispatch(CallCostDetailActions.callCostDetailLoad());
   }

   ngOnDestroy(): void {
      this.destroyed$.next();
   }

   onFormSaveCanceled(): void {
      this.store.dispatch(CallCostDetailActions.callCostDetailCancel());
   }

   onFormSubmitted(event: CallCostDetailSaveEvent): void {
      this.store.dispatch(CallCostDetailActions.saveCallCostDetail(event));
   }

   onDeleteCallCost(event: { providerCallRateId: number; destination: string | null }) {
      this.store.dispatch(CallCostDetailActions.deleteCallCost(event));
   }
}
